export const HeartRotate = () => {
    return <svg
    xmlns="http://www.w3.org/2000/svg"
    width={110}
    height={121}
    viewBox="0 0 110 121"
    fill="none"
  >
    <path
      d="M107.32 59.6763C119.474 22.5498 88.0608 -1.94151 57.3383 38.0253C52.5149 -13.3136 12.1115 -7.64028 2.94545 28.4985C-1.80557 47.2302 1.21707 64.4081 10.7918 83.8388L21.1505 104.067L32.5953 120.858L49.5033 112.536L68.939 101.208C82.8604 90.9063 100.964 79.0931 107.32 59.6763Z"
      fill="#C1C9B2"
    />
  </svg>  
}